import React from 'react';
import './NewAutocreatePage.css';
import '@shopify/polaris/dist/styles.css';
import Autocreate from '../components/Autocreate';
import AuthenticatedPage from '../components/AuthenticatedPage';

function NewAutocreatePage() {
  return (
    <AuthenticatedPage>
      {() => <Autocreate type="new" />}
    </AuthenticatedPage>
  );
}

export default NewAutocreatePage;
